import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Params } from '@angular/router';

@Injectable()
export class NotificationBarService {
  constructor() {}

  private _notifications: Subject<any> = new Subject();

  get notifications(): Observable<any> {
    return this._notifications.asObservable();
  }

  next(message: string, linkCaption?: string, routerCommands?: string[], params?: Params) {
    if (linkCaption && routerCommands)
      this._notifications.next({ message: message, link: { caption: linkCaption, routerCommands: routerCommands, params: params } });
    else this._notifications.next({ message: message });
  }
}
